import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var KeyIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.617 3.18198C16.3744 4.93934 16.3744 7.78858 14.617 9.54594C13.2316 10.9314 11.1675 11.2246 9.49477 10.4255L7.9203 12H7V12.9203L5.9203 14L5 14V14.9203L3.94974 15.9706L2.53552 15.9706L2.53552 13.1421L7.37346 8.3042C6.57441 6.63152 6.86761 4.56743 8.25306 3.18198C10.0104 1.42462 12.8597 1.42462 14.617 3.18198ZM13.2028 6.71751C13.7886 6.13173 13.7886 5.18198 13.2028 4.59619C12.617 4.01041 11.6673 4.01041 11.0815 4.59619C10.4957 5.18198 10.4957 6.13173 11.0815 6.71751C11.6673 7.3033 12.617 7.3033 13.2028 6.71751Z"
  }));
});
KeyIcon.displayName = 'KeyIcon';
export default KeyIcon;